module.exports = __webpack_public_path__ + "static/media/achievement-rocket-boots.a775b39b.svg";